import { useEffect, useState } from "react";

import ProjectBlock from "../../../../components/ProjectBlock/ProjectBlock";
import translate from "../../../../services/Translate";
import { fetchUserProjects } from "./UserProjects.function";

const UserProjects = ({ userId, language }: { userId: number; language: string }): JSX.Element => {
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserProjects(userId, setProjects, setLoading);
  }, [userId]);

  return (
    <div className="w-100">
      <h2 className="mb-3">{translate(language, "PAGES.USER.PROJECT.TITLE")}</h2>
      <div className="row w-100">
        {!loading ? (
          projects.length > 0 ? (
            projects.map((project: any, index: number) => (
              <div key={index} className="col-xl-4 col-md-6 col-sm-12 d-flex">
                <ProjectBlock
                  id={project.id}
                  type={project.subject.name}
                  title={project.name}
                  description={project.description}
                  overseer={project.overseer.full_name}
                  startDate={project.dt_start}
                  endDate={project.dt_end}
                  githubLink={project.url}
                  gradeScore={project.score ? `${project.score} / ${project.score_base}` : undefined}
                  externalDocumentsLinks={project.external_document_urls}
                />
              </div>
            ))
          ) : (
            <p>{translate(language, "PAGES.USER.PROJECT.NO_PROJECT")}</p>
          )
        ) : (
          <ProjectBlock mock id="" type="" title="" description="" overseer="" startDate="" endDate="" githubLink="" />
        )}
      </div>
    </div>
  );
};

export default UserProjects;
